import { render } from "./FpuiInputNumberWithButtons.vue?vue&type=template&id=1176f85e&lang=pug"
import script from "./FpuiInputNumberWithButtons.vue?vue&type=script&lang=js"
export * from "./FpuiInputNumberWithButtons.vue?vue&type=script&lang=js"

import "./FpuiInputNumberWithButtons.vue?vue&type=style&index=0&id=1176f85e&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__